import { useBreakpointValue } from '@chakra-ui/react';

import { commonUiStateSlice, useAppSelector } from '@app/app-state';

export const useIsMobileRes = () => {
    const isMobileBrowser = useAppSelector(commonUiStateSlice.selectors.selectIsMobileVersion);

    return useBreakpointValue(
        {
            base: true,
            lg: false,
        },
        {
            fallback: isMobileBrowser ? 'base' : 'lg',
        },
    );
};
